import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { Button as Button$1 } from '@popmenu/common-ui';
import { useButtonStyles } from './ButtonStyles.js';
import { deriveButtonProps } from './util/deriveButtonProps.js';

// eslint-disable-next-line react/display-name -- false positive
var Button = forwardRef(function (props, ref) {
    var children = props.children; props.variant; var classesOverride = props.classes, commonProps = __rest(props, ["children", "variant", "classes"]);
    var classes = useButtonStyles(props);
    var derivedProps = deriveButtonProps(props);
    var mergedProps = __assign(__assign({}, derivedProps), commonProps);
    return (React.createElement(Button$1, __assign({ ref: ref, classes: __assign(__assign({}, classes), classesOverride), disableElevation: true }, mergedProps), children));
});
Button.defaultProps = {
    textTransform: 'uppercase',
    variant: 'primary',
};
Button.displayName = 'Button';

export { Button };
//# sourceMappingURL=Button.js.map
